var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Menu'),_c('div',{staticClass:"container main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('SectionTitle',{attrs:{"title":"Pós Covid-19","description":"Atendimento pós covid-19","url":"/dashboard","enabledModalInformacao":false,"textModalInformacao":_vm.text}})],1)]),_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }